// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';

// IMPORT PROJECT REFERENCES
import { AnalysisCompleteUserStatsBrowser } from './AnalysisCompleteUserStatsBrowser';
import InputMask from 'react-input-mask';

const PAGE_SIZE = 10;

// COMPONENT
class AnalysisCompleteUserStatsWidget extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: null,
            endDate: null,
            startDateError: false,
            endDateError: false,
            epochStartDate: null,
            epochEndDate: null,
        };
    }

    onStartDateChange = evt => {
        this.setState({
            startDate: evt.target.value,
        });
    };

    onEndDateChange = evt => {
        this.setState({
            endDate: evt.target.value,
        });
    };

    onSubmit = evt => {
        evt.preventDefault();

        // validate inputs
        let startDateError = false,
            endDateError = false;
        if (this.state.startDate) {
            const startDate = Date.parse(this.state.startDate);

            if (!startDate) {
                startDateError = true;
            } else {
                this.setState({ epochStartDate: startDate });
            }
        }

        if (this.state.endDate) {
            const endDate = Date.parse(this.state.endDate);

            if (!endDate) {
                endDateError = true;
            } else {
                this.setState({ epochEndDate: endDate });
            }
        }

        this.setState({ startDateError: startDateError, endDateError: endDateError });
    };

    render() {
        return (
            <div className="card bg-light mb-3">
                <div className="card-body">
                    <div className="card-title">
                        <div className="d-flex justify-content-between">
                            <h6>Analysis Leaderboard</h6>
                        </div>
                    </div>
                    <form className="form-inline mb-3" onSubmit={this.onSubmit}>
                        <div
                            className={
                                'input-group' + (this.state.startDateError ? ' is-invalid' : '')
                            }
                        >
                            <label htmlFor="startDate" className="col-form-label col-form-label-sm">
                                Start
                            </label>
                            <InputMask
                                id="startDate"
                                className={
                                    'form-control form-control-sm mr-sm-2 ml-sm-2 leaderboard-date' +
                                    (this.state.startDateError ? ' is-invalid' : '')
                                }
                                mask="99/99/9999"
                                onChange={this.onStartDateChange}
                            />
                            <span className="invalid-feedback">Invalid Start Date</span>
                        </div>
                        <div
                            className={
                                'input-group' + (this.state.endDateError ? ' is-invalid' : '')
                            }
                        >
                            <label htmlFor="endDate" className="col-form-label col-form-label-sm">
                                End
                            </label>
                            <InputMask
                                id="endDate"
                                className={
                                    'form-control form-control-sm mr-sm-2 ml-sm-2 leaderboard-date' +
                                    (this.state.endDateError ? ' is-invalid' : '')
                                }
                                mask="99/99/9999"
                                onChange={this.onEndDateChange}
                            />
                            <span className="invalid-feedback">Invalid End Date</span>
                        </div>
                        <button className="btn btn-sm btn-outline-primary">Update</button>
                    </form>
                    <AnalysisCompleteUserStatsBrowser
                        pageSize={PAGE_SIZE}
                        startDate={this.state.epochStartDate}
                        endDate={this.state.epochEndDate}
                    />
                </div>
            </div>
        );
    }
}

export { AnalysisCompleteUserStatsWidget };
